import { ICard } from './card/card.interface';
import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';

export const CANNOT_BE_DEFAULT_TITLE = 'notifications.card.failure.cannot-be-default-title';
export const CANNOT_BE_DEFAULT_MSG = 'notifications.card.failure.cannot-be-default-message';

export enum CardsActionType {
    ADD_CARD_REQUEST = 'ADD_CARD_REQUEST',
    ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS',
    ADD_CARD_FAILURE = 'ADD_CARD_FAILURE',

    REMOVE_CARD_REQUEST = 'REMOVE_CARD_REQUEST',
    REMOVE_CARD_SUCCESS = 'REMOVE_CARD_SUCCESS',
    REMOVE_CARD_FAILURE = 'REMOVE_CARD_FAILURE',

    UPDATE_CARD_REQUEST = 'UPDATE_CARD_REQUEST',
    UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS',
    UPDATE_CARD_FAILURE = 'UPDATE_CARD_FAILURE',

    GET_CARDS_REQUEST = 'GET_CARDS_REQUEST',
    GET_CARDS_SUCCESS = 'GET_CARDS_SUCCESS',
    GET_CARDS_FAILURE = 'GET_CARDS_FAILURE',

    SET_IS_PRIMARY = 'SET_IS_PRIMARY',

    CLOSE_CARD_FORM = 'CLOSE_CARD_FORM',
    OPEN_CARD_FORM = 'OPEN_CARD_FORM',
}

export type CardsAction =
    | { type: CardsActionType.ADD_CARD_SUCCESS; payload: { card: ICard } }
    | { type: CardsActionType.REMOVE_CARD_SUCCESS; payload: { cardToken: string } }
    | { type: CardsActionType.UPDATE_CARD_SUCCESS; payload: { card: ICard } }
    | { type: CardsActionType.GET_CARDS_SUCCESS; payload: { cards: ICard[] } }
    | { type: CardsActionType.CLOSE_CARD_FORM; payload: {} }
    | { type: CardsActionType.OPEN_CARD_FORM; payload: {} }
    | ICardsFailureAction
    | ICardsRequestAction;

export interface ICardsRequestAction {
    type:
        | CardsActionType.ADD_CARD_REQUEST
        | CardsActionType.REMOVE_CARD_REQUEST
        | CardsActionType.UPDATE_CARD_REQUEST
        | CardsActionType.GET_CARDS_REQUEST
        | CardsActionType.SET_IS_PRIMARY;
    payload: {};
}

export interface ICardsFailureAction {
    type:
        | CardsActionType.ADD_CARD_FAILURE
        | CardsActionType.REMOVE_CARD_FAILURE
        | CardsActionType.UPDATE_CARD_FAILURE
        | CardsActionType.GET_CARDS_FAILURE;
    payload: { errorResolution: ErrorResolution };
}
